<template>
  <div>
    <div class="section mb-4" v-if="entryDetails">
      <template v-if="currentSection=='Entry Details'">
        <h2>Entry Details</h2>
        <div class="hr"></div>
        <div id="exhibitor" class='mb-2'>
          <div id="exhibitor" class='mb-3 bg-gray-200 px-3 py-4 rounded-lg' >
            <h3  class="mb-2 text-lg font-medium">Exhibitor</h3>
            <select-exhibitor :isAdmin="isAdmin" :user_id="newEntry.user_id" :initExhibitor="newEntry.exhibitor" v-model="newEntry.exhibitor" @input="setExhibitorProperties"/>
          </div>
        </div>
        <div class="hr"></div>
        <template v-if="newEntry.exhibitor">
          <div class="bg-gray-200 px-3 py-4 rounded-lg" v-if="(selectedEntryType.identifier.split('_')[0] === 'ABGA' || selectedEntryType.identifier.split('_')[0] === 'JABGA') || selectedEntryType.class_calc.ABGA || (selectedEntryType.identifier.includes('ABGA') && showList[0].type === 'BREEDING')">
            <h3 class="mb-2 text-lg font-medium">Goat Search Tool</h3>
            <showman-type-ahead class="mt-1" @valueChange="setEntryDetails" :placeholder="'Start typing to select or change animal'" :label="'Animal'" :dataEndpoint="'/callFunction/getGoatsSearch'" :schema="typeAheadSchema" :internalSearch="false"></showman-type-ahead>
            <p class="mt-1">Goat details will be auto populated after selecting an animal</p>
            <p class='mt-1 text-gray-700 text-sm'>*You can manually enter animal detail if you don't see the correct one in the list.</p>
          </div>

          <div v-else-if="exhibitorAnimalList.length && showAnimalSelect" id="Animal Select">
            <div class='mb-2'>
              <div class='mb-3 bg-gray-200 px-3 py-4 rounded-lg' >
              <h3 class="mb-2 text-lg font-medium">Choose the animal you are going to show:</h3>
              <multiselect @input="setAnimalEntryDetails" class="mt-1" v-model="newEntry.animal" :options="exhibitorAnimalList" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select previous animal" :preselect-first="false" :custom-label="(option) => {return animalSelectLabel(option)}" :hideSelected="false"></multiselect>
              <div class="border bg-red-200 rounded text-red-900 p-3 mt-2" v-if="showAnimalEditWarning">
                <p class="text-lg mb-2 font-medium">Are you trying to add in a new animal?</p>
                <p>If you want to add a new animal select the option to "Enter a new Animal" from the dropdown above. If you are correcting or updating the ID information for the currently selected animal you can continue to do so.</p>
              </div>
              <p v-else class="text-base text-gray-800 font-medium pt-1">To enter a new animal select the option titled <span class="font-bold text-black">"Enter a new Animal"</span> in the dropdown.</p>
              <!--Figure out the UI for this...-->
              <!--<div v-if="addNickname && newEntry.animal" class="mt-4">
                <label class="block text-gray-700 text-sm font-bold mb-2" for="nickname">
                  <span class="text-sm text-red-600 mr-1">*</span>Nickname/Barn Name
                </label>
                <input v-model="newEntry.entry_details.nickname" class="text-input focus:outline-none focus:shadow-outline">
                <p class="text-gray-600 text-sm mt-0.5">Either a nickname or barn name for this animal. This is for helping you keep track of animals.</p>
              </div>-->
              <!--<h3 class="my-2 text-lg font-medium">Or Enter a new animal:</h3>
              <button class="btn btn-sm btn-blue" @click="newAnimalSelected">Enter a new Animal</button>-->
            </div>
          </div>

          <div class="hr"></div>
          </div>
          <div v-if="!exhibitorAnimalList.length || newEntry.animal || !showAnimalSelect" class="w-full mt-4">
            <h3 class="text-xl font-light mb-2 pb-1 border-b">{{selectedEntryType.label}}</h3>
            <div v-if="addNickname" class="w-full mb-4">
              <label class="block text-gray-700 text-base font-bold mb-2" for="d.model">
                Animal Nickname/ID
              </label>
              <input v-model="newEntry.entry_details.nickname" class="new-form-input w-full">
              <p class="mt-1 text-sm text-gray-900">What do you call this animal around the barn? This is a unique name/field to help you keep your animals straight.</p>
            </div>
            <div v-if="event.event_settings.dynamic_class_lists && divisionList.length > 1" class='mb-2'>
              <label class="block text-gray-700 text-sm font-bold mb-2" for="d.model">
                <span class="text-sm text-red-600 mr-1">*</span>Division
              </label>
              <div class="relative">
                <select v-model="newEntry.entry_details.division" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-state">
                  <option :value="null" selected disabled>
                    Please select a division
                  </option>
                  <option v-for="(v, i) in divisionList" :key="i" :value="v.value">
                    {{v.label}}
                  </option>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
            <form-generator :form_schema="entryDetailFields" :show_label="false" :isAdmin="isAdmin" ref="series_form" :country="event.location_details.country"/>
          </div>
          <template v-if="isAdmin && newEntry.created_at && !isSubstitute">
            <div class="hr"></div>
            <div class="bg-gray-200 p-4 rounded">
              <label class="block text-gray-800 text-sm font-bold mb-2" for="d.model">
                Override Entry Created Date (optional)
              </label>
              <input type="datetime-local" v-model="newEntry.created_at" class="text-input focus:outline-none focus:shadow-outline">
              <span class="text-sm text-gray-800">Current Entry Date: {{formatDate(newEntry.created_at)}}</span>
            </div>
          </template>
        </template>
      </template>
      <!--Show-->
      <template v-if="currentSection=='Shows'">
        <h2>Shows</h2>
        <div class='hr'></div>
        <h5>Select which shows you are entering?</h5>
        <multiselect v-model="newEntry.shows" :options="showList" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Select a show to enter" label="name" track-by="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true"></multiselect>
      </template>

      <!--Class-->
      <template v-if="currentSection=='Class'">
        <h2>Classes</h2>
        <div class="hr"></div>
        <h5>Which Class are you entering?</h5>
        <div v-if="selectedEntryType.class_calc.calculate_by !== 'none'">
          <div v-if="computedClass">
            <div class="relative">
              <select v-model="newEntry.class_id" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" >
                <option disabled :value="null" >Select a Class</option>
                <option v-if="computedClassList.length === 1" selected :value="computedClass.classID">
                  {{classToString(computedClass)}}
                </option>
                <template v-else>
                  <template  v-for="(c, i) in computedClassList">
                    <option :key="i" :value="c.classID" v-if="isAdmin || (c.settings ? !c.settings.admin_only : true)">
                      {{classToString(c)}}
                    </option>
                  </template>
                </template>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="bg-red-lightest text-red-dark px-4 py-3 rounded relative my-2 border border-red-lighter" role="alert">
              <p class="text-xl mb-2">Uh oh, go back and check your date of birth again!</p>
              <span v-if="entryType==='SHOWMANSHIP'">Either your birth date is wrong or your showman may be too young.</span>
              <span v-else>Either your birth date is wrong or you didn't select a correct division</span>
              <button class="btn btn-link" variant="link" @click="currentSection='Entry Details'">Go To Entry Details</button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="relative">
            <select v-model="newEntry.class_id" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" >
              <option disabled selected :value="null" >Select a Class</option>
              <!--<option v-for="c in classList" v-if="c.entryType=='standard'" :key="c.classID" :value="c.classID">-->
              <option v-for="c in classList.filter((c) => c.entryType ==='standard')" :key="c.classID" :value="c.classID">
                {{classToString(c)}}
              </option>
            </select>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
            </div>
          </div>
        </div>
      </template>

      <!--Confirm Entry-->
      <template v-if="currentSection=='Confirm Entry'">
        <h2>Confirm</h2>
        <div class="hr"></div>
        <div class="flex justify-between mb-4">
          <div id="confirm-shows" class="flex-1" v-if="entry_sections.indexOf('Shows')>-1">
            <p class="text-2xl">Shows</p>
            <ul>
              <li v-for="(s,ind) in newEntry.shows" :key="ind">
                {{s.name}}
              </li>
            </ul>
            <button class="btn-gray btn-sm" @click="sectionIndex=entry_sections.indexOf('Shows')">Edit</button>
          </div>
          <div id="confirm-class" class="flex-1">
            <p class="text-2xl">Class</p>
            <p>{{classToString(classList.find(c => c.classID === newEntry.class_id))}}</p>
            <button class="btn-gray btn-sm" @click="sectionIndex=entry_sections.indexOf('Class')">Edit</button>
          </div>
        </div>

        <div class="flex justify-between mb-8" v-if="entry_sections.indexOf('Entry Details')>-1">
          <div class="flex-1">
            <p class="text-2xl">Entry Details</p>
            <ul class="leading-normal">
              <li v-if="newEntry.exhibitor"><b>Exhibitor: </b>{{newEntry.exhibitor.first_name}} {{newEntry.exhibitor.last_name}}</li>
              <li v-if="newEntry.entry_details.division"><b>Division: </b>{{newEntry.entry_details.division}}</li>
              <div v-for="(s, x) in entryDetailFields" :key="x">
                <li v-for="(d, z) in s.fields" :key="z" class="flex space-x-1">
                  <template v-if="(isAdmin || !d.admin_only) && d.model !== 'division'">
                    <b>{{`${d.label}:&nbsp;`}}</b>
                    <template v-if="newEntry.entry_details[d.model]">
                      <template v-if="d.inputType==='date'">
                        {{`${formatDate(newEntry.entry_details[d.model])}`}}
                      </template>
                      <template v-else-if="d.type==='picture'">
                        <img :src="newEntry.entry_details[d.model]"/>
                      </template>
                      <template v-else-if="d.type==='video'">
                        <video width="320" height="240" controls>
                          <source :src="s.model[d.model]" type="video/mp4">
                          <source :src="s.model[d.model]" type="video/webm">
                          <source :src="s.model[d.model]" type="video/ogg">
                        </video>
                      </template>
                      <template v-else-if="d.type==='link'">
                        <a :href="`${newEntry.entry_details[d.model]}`" target="_blank" class="link">{{`${newEntry.entry_details[d.model]}`}}</a>
                      </template>
                      <template v-else-if="d.type==='file'">
                        <display-file-type-field :title="d.label" :url="newEntry.entry_details[d.model]"/>
                      </template>
                      <template v-else>
                      {{`${newEntry.entry_details[d.model]}`}}
                      </template>
                    </template>
                  </template>
                </li>
              </div>
            </ul>
            <button class="btn-gray btn-sm" @click="sectionIndex=entry_sections.indexOf('Entry Details')">Edit</button>
          </div>

          <!--<div class="flex-1">
            <p class="text-2xl mb-1">Edit Entry Type</p>
            <multiselect @input="entryTypeChage" v-model="selectedEntryType" :options="allEntryTypes" :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :preselect-first="false" :custom-label="(option) => {return option.label}" :hideSelected="true"></multiselect>
            <p class='text-gray-700 text-sm mt-1'>Select a new "Entry Type" above if you would like substitute this entry for a different type.</p>
          </div> -->
        </div>
      </template>

      <template v-if="!entryLoading">
        <div class='mt-2 flex justify-between'>
          <button v-if="sectionIndex > 0 && !isEdit" class="btn btn-gray mr-2" @click="moveBack">Back</button>
          <button v-else-if="sectionIndex != entry_sections.length - 1 && isEdit" class="btn btn-gray mr-2" @click="sectionIndex = entry_sections.length-1">Back</button>
          <span v-else></span>
          <template v-if="!isEdit || isSubstitute">
            <button v-if="sectionIndex < entry_sections.length - 1" class="btn btn-gray" @click="moveNext">Next</button>
            <button v-else @click="createEntry" class="btn btn-blue">Add Entry</button>
          </template>
          <template v-else>
            <button v-if="sectionIndex != entry_sections.length - 1" class="btn btn-blue" @click="checkEdit(entry_sections[sectionIndex])">Save</button>
            <button v-else @click="cancel" class="btn btn-blue">Done Editing</button>
          </template>
        </div>
      </template>
      <template v-else-if="entryLoading">
        <vue-simple-spinner size="large" :speed="1.1" :line-size="7" message="Adding Entry" line-fg-color="orange"/>
      </template>

    </div>
    <div class="hr"></div>
    <button class="btn btn-red float-right mt-2" @click="cancel">Cancel</button>
  </div>
</template>

<script>
import ShowmanTypeAhead from '@/components/ShowmanTypeAhead.vue'
import SelectExhibitor from '@/components/SelectExhibitor.vue'
import {format, parse, differenceInMonths, differenceInYears, isWithinRange} from 'date-fns'
import FormGenerator from '@/components/FormGenerator.vue'

export default {
  components: {
    ShowmanTypeAhead,
    SelectExhibitor,
    FormGenerator
  },
  name: 'new-entry',
  props: {
    event: Object,
    newEntry: Object,
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      typeAheadSchema: {
        idField: 'goat_id',
        searchField1: 'name',
        searchField2: 'reg_num',
        displayTemplate: '$1 ($2) ~ $3, $4',
        displayFields: ['name', 'reg_num', {value: 'date_of_birth', func: (date) => { return this.Localized.formatDateFullYear(date, this.event.location_details.country) }}, 'division']
      },
      sectionIndex: 0,
      entry_sections: ['Shows', 'Entry Details', 'Class', 'Confirm Entry'],
      entryLoading: false,
      selectedEntryType: {},
      computedClass: null,
      computedClassList: [],
      image: {},
      imageLoaded: false,
      imageLoading: false,
      imageError: null,
      newAnimalID: 'Enter a new Animal',
      isSubstitute: false
    }
  },
  methods: {
    setSelectedEntryType (entryType) {
      this.selectedEntryType = entryType
    },
    setSectionIndex (index) {
      this.sectionIndex = index
    },
    createEntry: function () {
      this.entryLoading = true
      if (this.newEntry.entry_details.date_of_birth) {
        this.newEntry.entry_details.date_of_birth = format(parse(this.newEntry.entry_details.date_of_birth), 'YYYY-MM-DD')
      }

      this.newEntry.entry_type = this.selectedEntryType.identifier
      this.updateAnimalProperties()
      this.saveExhibitor()
        .then(response => {
          // Set Exhibitor ID
          this.newEntry.exhibitor_id = response.exhibitor_id
          // Emmit save
          this.$emit('addEntry', this.newEntry)
        })
      // this.$emit('addEntry', this.newEntry)
    },
    editEntry: function () {
      this.entryLoading = true
      this.calculateComputedClass()
      if (this.currentSection === 'Entry Details' && this.newEntry.entry_details.division) {
        this.newEntry.class_id = this.computedClass.classID
      }
      // Added
      this.newEntry.class_number = this.computedClass.class_number
      this.updateAnimalProperties()
      if (this.currentSection === 'Entry Details') {
        this.saveExhibitor()
          .then(response => {
            this.newEntry.exhibitor_id = response.exhibitor_id
            this.$emit('editEntry', this.currentSection)
          })
      } else {
        this.$emit('editEntry', this.currentSection)
      }
    },
    classToString (c) {
      if (c) {
        return c.className
      }
    },
    cancel () {
      this.sectionIndex = 0
      this.entryLoading = false
      this.$emit('cancel')
    },
    reset () {
      if (this.entry_sections) {
        this.sectionIndex = this.isEdit ? this.entry_sections.length - 1 : 0
      } else {
        this.sectionIndex = 0
      }
      this.entryLoading = false
    },
    moveNext () {
      if (this.currentSection === 'Entry Details') {
        if (this.newEntry.exhibitor) {
          if (this.validateEntryDetails()) {
            this.calculateComputedClass()
            if (this.newEntry.class_id) {
              this.sectionIndex += 2
            } else {
              this.sectionIndex++
            }
          }
        } else {
          this.notie.alert({
            type: 3,
            text: `<b>Exhibitor is Required</b><br>Please select an exhibitor and try again.`
          })
        }
      } else if (this.currentSection === 'Shows') {
        if (!Array.isArray(this.newEntry.shows) || !this.newEntry.shows.length) {
          this.$emit('error', 'Please select at least one show')
        } else {
          this.sectionIndex++
        }
      } else if (this.currentSection === 'Class') {
        if (!this.newEntry.class_id) {
          this.$emit('error', 'Please Select a Class')
        } else {
          this.sectionIndex++
        }
      }
    },
    moveBack () {
      this.sectionIndex--
    },
    formatDate (date) {
      return this.Localized.formatDateFullYear(date, this.event.location_details.country)
    },
    checkEdit () {
      if (this.currentSection === 'Entry Details') {
        if (this.newEntry.exhibitor) {
          if (this.validateEntryDetails()) {
            this.editEntry()
          } else {
            // console.log('dont edit')
          }
        } else {
          this.notie.alert({
            type: 3,
            text: `<b>Exhibitor is Required</b><br>Please select an exhibitor and try again.`
          })
        }
      } else if (this.currentSection === 'Shows') {
        if (!Array.isArray(this.newEntry.shows) || !this.newEntry.shows.length) {
          this.$emit('error', 'Please select at least one show')
        } else {
          this.editEntry()
        }
      } else if (this.currentSection === 'Class') {
        if (!this.newEntry.class_id) {
          this.$emit('error', 'Please Select a Class')
        } else {
          this.editEntry()
        }
      }
    },
    validateEntryDetails () {
      var isValid = true
      if (this.exhibitorAnimalList.length && this.showAnimalSelect) {
        if (!this.newEntry.animal) {
          this.notie.alert({
            type: 3,
            text: `<b>Please select an Animal to continue.</b><br> To enter a new animal select the option titled "Enter a new Animal" in the dropdown. `
          })
          return false
        }
      }
      this.entryDetailFields.forEach(s => {
        s.fields.forEach(f => {
          if (f.required && !(s.model[f.model] || s.model[f.model !== ''])) {
            if (isValid) {
              this.notie.alert({
                type: 3,
                text: `<b>${f.label} is required</b><br>Please update all fields and try again.`
              })
            }
            isValid = false
          }
        })
        // Check division
        if (this.divisionList.length > 1) {
          if (!this.newEntry.entry_details.division) {
            if (isValid) {
              this.notie.alert({
                type: 3,
                text: `<b>Division is required</b><br>Please update all fields and try again.`
              })
            }
            isValid = false
          }
        }
      })
      return isValid
    },
    setEntryDetails (selected) {
      this.entryDetailFields.forEach(ed => {
        ed.fields.forEach(f => {
          if (!f.exhibitor_field && !f.non_animal_field) {
            this.$set(this.newEntry.entry_details, f.model, selected[f.model])
          }
        })
        // Set Division
        this.$set(this.newEntry.entry_details, 'division', selected['division'])
      })
    },
    setAnimalEntryDetails (selected) {
      if (selected) {
        if (selected.animal_details.animal_id === this.newAnimalID) {
          this.setNewAnimalDetails()
        } else {
          // Set animal details when division list is dynamic
          if (this.divisionList.length > 1 && this.event.event_settings.dynamic_class_lists) {
            if (selected.animal_details['breed']) {
              if (this.divisionList.some(o => o.value === selected.animal_details['breed'])) {
                this.$set(this.newEntry.entry_details, 'division', selected.animal_details['breed'])
              }
            }

            // If division not set try settting the divison to the saved animal division
            if (!this.newEntry.entry_details.division) {
              if (this.divisionList.some(o => o.value === selected.animal_details['division'])) {
                this.$set(this.newEntry.entry_details, 'division', selected.animal_details['division'])
              }
            }
          }

          this.entryDetailFields.forEach(ed => {
            ed.fields.forEach(f => {
              if (f.model === 'division') {
                // Check if animal breed matches the division
                if (selected.animal_details['breed']) {
                  if (f.options.some(o => o.value === selected.animal_details['breed'])) {
                    this.$set(this.newEntry.entry_details, f.model, selected.animal_details['breed'])
                  }
                }

                // If division not set try settting the divison to the saved animal division
                if (!this.newEntry.entry_details.division) {
                  if (f.options.some(o => o.value === selected.animal_details['division'])) {
                    this.$set(this.newEntry.entry_details, f.model, selected.animal_details['division'])
                  }
                }
              } else if (!f.exhibitor_field && !f.non_animal_field) {
                this.$set(this.newEntry.entry_details, f.model, selected.animal_details[f.model])
              }
            })
          })
        }
      }
    },
    setNewAnimalDetails () {
      // Set all fields to null
      this.entryDetailFields.forEach(ed => {
        ed.fields.forEach(f => {
          if (!f.exhibitor_field && !f.non_animal_field) {
            this.$set(this.newEntry.entry_details, f.model, null)
          }
        })
      })
      if (this.divisionList.length > 1 && this.event.event_settings.dynamic_class_lists) {
        this.$set(this.newEntry.entry_details, 'division', null)
      }
    },
    newAnimalSelected () {
      this.newEntry.animal = this.newAnimalID
      this.setNewAnimalDetails()
    },
    updateAnimalProperties () {
      // let hasName = false
      // let hasAnimalID = false

      if (this.newEntry.animal) {
        this.entryDetailFields.forEach(ed => {
          ed.fields.forEach(f => {
            if (!f.exhibitor_field && !f.non_animal_field && f.model !== 'weight' && this.newEntry.entry_details[f.model]) {
              this.$set(this.newEntry.animal.animal_details, f.model, this.newEntry.entry_details[f.model])
            }
            /* if (f.model === 'animal_id') {
              hasAnimalID = true
            } else if (f.model === 'name') {
              hasName = true
            } */
          })
        })
        // Added this ot make sure the breed/division is set for the animal...
        if (this.newEntry.entry_details.division) {
          if (!this.newEntry.entry_details.breed) {
            this.$set(this.newEntry.animal.animal_details, 'breed', this.newEntry.entry_details.division)
          }
          this.$set(this.newEntry.animal.animal_details, 'division', this.newEntry.entry_details.division)
        }
        // Added this to mke srue nickname gets set
        if (this.newEntry.entry_details.nickname) {
          this.$set(this.newEntry.animal.animal_details, 'nickname', this.newEntry.entry_details.nickname)
        }

        // Removee unset animal ids
        if (this.newEntry.animal.animal_details.animal_id === this.newAnimalID) {
          delete this.newEntry.animal.animal_details.animal_id
        }
      }
    },
    setExhibitorProperties () {
      if (this.newEntry.exhibitor) {
        this.entryDetailFields.forEach(ed => {
          ed.fields.forEach(f => {
            if (f.exhibitor_field) {
              this.$set(this.newEntry.entry_details, f.model, this.newEntry.exhibitor.exhibitor_details[f.model])
            }
          })
        })
      }
    },
    saveExhibitor () {
      if (this.newEntry.exhibitor) {
        // Set Properties
        this.entryDetailFields.forEach(ed => {
          ed.fields.forEach(f => {
            if (f.exhibitor_field && this.newEntry.entry_details[f.model]) {
              this.newEntry.exhibitor.exhibitor_details[f.model] = this.newEntry.entry_details[f.model]
            }
          })
        })
        this.newEntry.exhibitor.isAdmin = this.isAdmin
        if (this.newEntry.exhibitor.exhibitor_id) {
          // Update Exhibitor
          return this.$store.dispatch('updateExhibitor', this.newEntry.exhibitor)
            .then(response => {
              if (this.isAdmin) {
                return this.$store.dispatch('checkExhibitorNumber', {exhibitor_id: this.newEntry.exhibitor.exhibitor_id, event_id: this.event.event_id})
                  .then(response => {
                    // console.log(response)
                    return Promise.resolve(this.newEntry)
                  })
              } else {
                return Promise.resolve(response)
              }
            })
        } else {
          // Commented out on 4/28/21 -- Added in code below
          // New Update Assumes that an exhbitor on an entry would already be added
          // Add Exhibitor
          this.newEntry.exhibitor.user_id = this.newEntry.user_id
          return this.$store.dispatch('addExhibitor', {exhibitor: this.newEntry.exhibitor, event_id: this.event.event_id})
            .then(response => {
              return Promise.resolve(response)
            })
        }
      }
    },
    calculateComputedClass () {
      var division = null
      // Filter out champion classes
      let filteredClassList = this.classList.filter((c) => {
        if (c.entryType.toLowerCase() === 'standard' && (!c.settings.admin_only || this.isAdmin)) {
          return true
        }
      })
      // Filter on division
      if (this.newEntry.entry_details.division) {
        division = this.newEntry.entry_details.division
        filteredClassList = filteredClassList.filter((c) => {
          if (division) {
            return c.division === division
          } else {
            return true
          }
        })
      }
      // Filter on Age
      if (this.newEntry.entry_details.date_of_birth) {
        var age = -1
        let ageDate = null
        if (this.event.event_settings.dynamic_class_lists) {
          filteredClassList = filteredClassList.filter(c => {
            if (c.age_unit) {
              // Filter by age as of show
              if (c.settings.base_date_day_of_show) {
                ageDate = this.event.shows.find(s => s.show_id === this.newEntry.shows[0].value).show_date
              } else {
                ageDate = c.settings.base_date
              }
              if (!ageDate) {
                return true
              }
              if (c.age_unit === 'MONTHS') {
                age = differenceInMonths(parse(ageDate), parse(this.newEntry.entry_details.date_of_birth))
              } else if (c.age_unit === 'YEARS') {
                age = differenceInYears(parse(ageDate), parse(this.newEntry.entry_details.date_of_birth))
              }
              if (c.settings.age_gap) {
                return age >= c.age_start && age <= c.age_end
              } else {
                return age >= c.age_start && age < c.age_end
              }
            } else if (c.range_start || c.range_end) {
              return isWithinRange(parse(this.newEntry.entry_details.date_of_birth), parse(c.range_start), parse(c.range_end))
            } else {
              return true
            }
          })
        } else {
          if (this.selectedEntryType.class_calc.age_date) {
            ageDate = this.selectedEntryType.class_calc.age_date
          } else if (this.newEntry.shows[0].type === 'SHOWMANSHIP' || this.newEntry.type === 'SHOWMANSHIP') {
            ageDate = this.event.entry_settings.showmanship_age_date
          } else {
            ageDate = this.event.entry_settings.breeding_age_date
          }

          if (this.selectedEntryType.class_calc.age_unit === 'Months') {
            age = differenceInMonths(parse(ageDate), parse(this.newEntry.entry_details.date_of_birth))
          } else if (this.selectedEntryType.class_calc.age_unit === 'Years') {
            age = differenceInYears(parse(ageDate), parse(this.newEntry.entry_details.date_of_birth))
          }
          filteredClassList = filteredClassList.filter((c) => {
            if (this.selectedEntryType.class_calc.calculate_by === 'age_range') {
              return isWithinRange(parse(this.newEntry.entry_details.date_of_birth), parse(c.ageRangeStart), parse(c.ageRangeEnd))
              // Try removing age > -1
            } else if (this.selectedEntryType.class_calc.calculate_by === 'age') {
              if (age > -1) {
                if (this.selectedEntryType.class_calc.age_gap) {
                  return age >= c.ageStart && age <= c.ageEnd
                } else {
                  return age >= c.ageStart && age < c.ageEnd
                }
              } else {
                return true
              }
            } else {
              return true
            }
          })
        }
      }

      // Filter to final Class List
      this.computedClass = filteredClassList[0]
      this.computedClassList = filteredClassList

      if (filteredClassList.length === 1) {
        this.newEntry.class_id = filteredClassList[0].classID
      }
      // Over Ride if only one class that got filtered incorrectly
      if (this.classList.length === 1) {
        this.computedClass = this.classList[0]
        this.newEntry.class_id = this.classList[0].classID
      }
    },
    onFileChange (result) {
      // console.log('file changes')
      // console.log(result)
      this.image = result
      /* this.$refs.croppieRef.bind({
        url: result
      }) */
      this.imageLoaded = true
      this.upload()
    },
    animalSelectLabel (option) {
      let labelParts = []
      if (option.animal_details.animal_id === 'Enter a new Animal') {
        labelParts.push(option.animal_details.animal_id)
      } else {
        if (option.animal_details.nickname) {
          labelParts.push(option.animal_details.nickname)
        } else if (option.animal_details.name) {
          labelParts.push(option.animal_details.name)
        }

        if (option.animal_details.breed) {
          labelParts.push(option.animal_details.breed)
        }

        if (option.species === 'GOATS' || option.species === 'SHEEP' || option.species === 'DAIRY GOATS') {
          if (option.animal_details.scrapie_tag) {
            labelParts.push(option.animal_details.scrapie_tag)
          } else if (option.animal_details.tag) {
            labelParts.push(option.animal_details.tag)
          } else {
            labelParts.push(option.animal_details.animal_id)
          }
        } else if (option.species === 'SWINE') {
          if (option.animal_details.ear_notch) {
            labelParts.push(option.animal_details.ear_notch)
          } else if (option.animal_details.tag) {
            labelParts.push(option.animal_details.tag)
          } else if (option.animal_details['840_tag']) {
            labelParts.push(option.animal_details['840_tag'])
          } else {
            labelParts.push(option.animal_details.animal_id)
          }
        } else if (option.species === 'CATTLE' || option.species === 'DAIRY CATTLE') {
          if (option.animal_details.rfid_tag) {
            labelParts.push(option.animal_details.rfid_tag)
          } else if (option.animal_details['840_tag']) {
            labelParts.push(option.animal_details['840_tag'])
          } else if (option.animal_details.tattoo) {
            labelParts.push(option.animal_details.tattoo)
          } else if (option.animal_details.tag) {
            labelParts.push(option.animal_details.tag)
          } else {
            labelParts.push(option.animal_details.animal_id)
          }
        } else {
          if (option.animal_details.rfid_tag) {
            labelParts.push(option.animal_details.rfid_tag)
          } else if (option.animal_details['840_tag']) {
            labelParts.push(option.animal_details['840_tag'])
          } else if (option.animal_details.tattoo) {
            labelParts.push(option.animal_details.tattoo)
          } else if (option.animal_details.tag) {
            labelParts.push(option.animal_details.tag)
          } else {
            labelParts.push(option.animal_details.animal_id)
          }
        }

        // Last resort to add some sort of label
        if (labelParts.length === 0) {
          labelParts.push(option.animal_details.animal_id)
        }
      }
      return labelParts.join(' ~ ')
    },
    entryTypeChage () {
      this.isSubstitute = true
      this.newEntry.animal = null
      this.newEntry.shows = []
      this.sectionIndex = this.entry_sections.indexOf('Shows')
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    AllAnimals () {
      if (this.isAdmin) {
        // return this.$store.state.admin.adminData.current_animals
        // Filter out inactive animals
        return this.$store.state.admin.adminData.current_animals.filter(a => {
          return a.status === 'ACTIVE'
        })
      } else if (this.currentUser) {
        // Filter out inactive animals
        return this.$store.state.userData.animals.filter(a => {
          return a.status === 'ACTIVE'
        })
      } else {
        return []
      }
    },
    exhibitorAnimalList () {
      if (this.newEntry.exhibitor) {
        let list = this.AllAnimals.filter(a => {
          // return a.type === this.showList[0].type && a.species === this.showList[0].species && a.exhibitor_id === this.newEntry.exhibitor.exhibitor_id
          // Dont filter by type
          return a.species === this.showList[0].species && a.exhibitor_id === this.newEntry.exhibitor.exhibitor_id
        })
        list.push({
          exhibitor_id: this.newEntry.exhibitor.exhibitor_id,
          species: this.showList[0].species,
          type: this.showList[0].type,
          animal_details: {
            animal_id: this.newAnimalID
          }
        })
        return list
      } else {
        return []
      }
    },
    showAnimalSelect () {
      if (this.showList[0].type === 'SHOWMANSHIP' || this.showList[0].type === 'GROUP' || this.showList[0].type === 'EXHIBIT' || this.showList[0].type === 'CONTEST') {
        return false
      }
      // if An ABGA animal don't use animal select
      if ((this.selectedEntryType.identifier.split('_')[0] === 'ABGA' || this.selectedEntryType.identifier.split('_')[0] === 'JABGA') || this.selectedEntryType.class_calc.ABGA || this.selectedEntryType.identifier.includes('ABGA')) {
        return false
      }

      if (!this.isEdit) {
        return true
      } else if (this.isSubstitute) {
        return true
      } else {
        if (this.newEntry.animal) {
          return true
        } else {
          return false
        }
      }
    },
    showAnimalEditWarning () {
      if (this.newEntry.animal) {
        if (this.newEntry.animal.animal_details.animal_id === this.newAnimalID) {
          return false
        } else if (this.newEntry.animal.animal_details.animal_id !== this.newEntry.entry_details.animal_id && this.newEntry.entry_details.animal_id) {
          return true
        } else if (this.newEntry.animal.animal_details.name !== this.newEntry.entry_details.name && this.newEntry.entry_details.name) {
          return true
        }
      }
      return false
    },
    entryDetails () {
      return this.selectedEntryType.entry_details
    },
    entryType () {
      return this.selectedEntryType.type
    },
    showList () {
      // return this.selectedEntryType.show_ids
      return this.event.shows.filter(s => {
        return this.selectedEntryType.show_ids.indexOf(s.show_id) > -1
      }).map(s => {
        s.value = s.show_id
        return s
      })
    },
    classList () {
      return this.selectedEntryType.class_list
    },
    currentSection () {
      if (this.entry_sections) {
        return this.entry_sections[this.sectionIndex]
      } else {
        return 'Shows'
      }
    },
    entryDetailFields () {
      let fields = []
      this.entryDetails.forEach(e => [
        fields.push(e)
      ])
      /* if (this.addNickname) {
        fields[0].fields.unshift({
          label: 'Animal Nickname/ID',
          model: 'nickname',
          type: 'input',
          required: false,
          inputType: 'text',
          admin_only: false,
          hint: 'What do you call this animal in the barn? This should be a unique name to help you keep animals straight when entering.'
        })
      } */

      if (this.addDeclaredWeight) {
        fields[0].fields.push({
          label: 'Declared Weight',
          model: 'weight',
          type: 'input',
          required: false,
          inputType: 'number',
          admin_only: false,
          hint: this.selectedEntryType.class_calc.declared_weight_hint
        })
      }
      if (this.selectedEntryType.sub_entry_details) {
        let keysToAdd = []
        let subKeys = Object.keys(this.selectedEntryType.sub_entry_details)
        subKeys.forEach(k => {
          this.newEntry.shows.forEach(s => {
            if (s.name.search(k) > -1) {
              keysToAdd.push(k)
            }
          })
        })
        let uniqueKeys = [...new Set(keysToAdd)]
        uniqueKeys.forEach(key => {
          fields.push(this.selectedEntryType.sub_entry_details[key][0])
        })
      }
      return fields.map(s => {
        s.model = this.newEntry.entry_details
        return s
      })
    },
    differentShows () {
      let shows = []
      if (this.newEntry.shows) {
        this.newEntry.shows.forEach(s => {
          shows.push(s)
        })
      }
      return shows
    },
    isEdit () {
      return !!this.newEntry.entry_ids // ? true : false
    },
    divisionList () {
      let div = []
      if (this.event.event_settings.dynamic_class_lists) {
        this.classList.forEach(c => {
          // Add in to avoid selecting the division when using age divisions...
          // if (c.entryType.toLowerCase() === 'standard' && (!c.settings.admin_only || this.isAdmin) && !c.settings.hide_from_division_list && (!c.age_unit && !c.range_start && !c.range_end)) {
          if (c.entryType.toLowerCase() === 'standard' && (!c.settings.admin_only || this.isAdmin) && !c.settings.hide_from_division_list) {
            if (!div.find(d => d.value === c.division)) {
              // Don't allow division select for Showmanship...
              // But allow for Klamath County Fair and Cass county Fair
              if (!c.className.toLowerCase().includes('showmanship') || this.event.name.includes('Klamath County Fair') || this.event.name.includes('Cass County Fair')) {
                div.push({
                  label: c.settings.division_label ? c.settings.division_label : c.division,
                  value: c.division,
                  admin_only: c.settings.admin_only
                })
              }
            }
          }
        })
      }
      // Switched to a natural sort to help with numbers/grades
      return div.sort((aObjc, bObjc) => {
        let a = aObjc.label
        let b = bObjc.label
        var aNumMatch = a.match(/^\d+/)
        var bNumMatch = b.match(/^\d+/)

        if (aNumMatch && bNumMatch) {
          var aNum = parseInt(aNumMatch[0])
          var bNum = parseInt(bNumMatch[0])
          if (aNum !== bNum) {
            return aNum - bNum
          }
        }
        // If the numeric parts are equal, perform a standard alphanumeric comparison
        return a.localeCompare(b)
      })
    },
    allEntryTypes () {
      return this.event.show_types
    },
    addDeclaredWeight () {
      let weightFound = false
      if (this.selectedEntryType.class_calc.declared_weight) {
        this.selectedEntryType.entry_details.forEach(s => {
          s.fields.forEach(f => {
            if (f.model === 'weight' && !f.admin_only) {
              weightFound = true
            }
          })
        })
        if (!weightFound) {
          return true
        }
      }
      return false
    },
    addNickname () {
      let nicknameFound = false
      this.selectedEntryType.entry_details.forEach(s => {
        s.fields.forEach(f => {
          if (f.model === 'nickname') {
            nicknameFound = true
          }
        })
      })
      if (!nicknameFound && this.showAnimalSelect) {
        return true
      }
      return false
    }
  },
  watch: {
    currentSection () {
      if (this.currentSection === 'Class' || (this.currentSection === 'Confirm Entry')) { // && this.classList.length === 1)) {
        this.calculateComputedClass()
      }
    }
  }
}
</script>

<style>

</style>
